import { useQuery } from '@tanstack/react-query';

import type { UseContactsParams, UseContactsReturn } from './useContacts.types';

import { getContacts } from '../../api/get-contacts/getContacts';

export function useContacts({
  organizationId,
  enabled,
}: UseContactsParams): UseContactsReturn {
  return useQuery({
    queryKey: ['contacts', organizationId],
    queryFn: () => getContacts(organizationId),
    enabled: enabled && !!organizationId,
  });
}
